import type { FC } from 'react';

import Template from '../Template';
import { listDesktop, listMobile } from './content';

const Firefox: FC = () => {
    return <Template listDesktop={listDesktop} listMobile={listMobile} />;
};

export default Firefox;
